import { PaginationQuery, UserListResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface UseUsersParams extends PaginationQuery {
  search?: string
  providerId?: number
}

export function useUsers({ page = 1, pageSize = 10, search, providerId }: UseUsersParams) {
  const { token } = useAuth()

  const params: Record<string, unknown> = {
    page,
    pageSize,
  }

  if (search) params.search = search
  if (providerId) params.providerId = providerId

  const { data, error, mutate } = useGet<UserListResponse>(
    token ? '/api/users' : null,
    params,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    users: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
